import styled from "styled-components";

export const ScopeWrapper = styled.div`
  display: flex;
  align-items: center;
`;
